import { render, staticRenderFns } from "./KidsProductImages.vue?vue&type=template&id=0783b4ca&scoped=true"
import script from "./KidsProductImages.vue?vue&type=script&lang=js"
export * from "./KidsProductImages.vue?vue&type=script&lang=js"
import style0 from "./KidsProductImages.vue?vue&type=style&index=0&id=0783b4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0783b4ca",
  null
  
)

export default component.exports